import { getIn } from 'final-form';

/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */
function findInput(inputs, errors) {
  return inputs.find(input => input.name && getIn(errors, input.name));
}
export default findInput;